import HeroSection from "../components/HeroSection";
import AboutDoctor from "../components/AboutDoctor";
import ServicesGrid from "../components/ServicesGrid";
import EmergencyCare from "../components/EmergencyCare";
import FeaturedProcedures from "../components/FeaturedProcedures";
import WhyChoose from "../components/WhyChoose";
import Locations from "../components/Locations";
import Testimonials from "../components/Testimonials";
import BlogPreview from "../components/BlogPreview";
import FAQ from "../components/FAQ";
import FinalCTA from "../components/FinalCTA";

export default function Home({ onBookAppointment }) {
  return (
    <main data-testid="home-page">
      <HeroSection onBookAppointment={onBookAppointment} />
      <AboutDoctor />
      <ServicesGrid />
      <EmergencyCare />
      <FeaturedProcedures onBookAppointment={onBookAppointment} />
      <WhyChoose />
      <Locations />
      <Testimonials />
      <BlogPreview />
      <FAQ />
      <FinalCTA onBookAppointment={onBookAppointment} />
    </main>
  );
}
